<template>
  <app-page-container extra>
    <app-spinner v-if="!is_page_loaded" />
    <template v-else>
      <app-cells><h2 class="title">Personal data</h2></app-cells>
      <v-client-table
        :data="table_personal.items"
        :columns="table_personal.columns"
        :options="table_personal.options"
        class="table-default"
      >
        <template #h__full_name><div class="table-default__left">Full name</div></template>
        <template #count="{ row, index }">{{ index }}</template>
        <template #full_name="{ row }">
          <div class="table-default__left">
            <button
              @click="onCopyToClipboard(row.full_name)"
              class="table-default__copy"
              :class="{'table-default__copy--disabled': !row.full_name}"
            >
              {{ row.full_name }}
            </button>
          </div>
        </template>
        <template #dob="{ row }">
          <button
            @click="onCopyToClipboard(dateFormat(row.dob))"
            class="table-default__copy"
            :class="{'table-default__copy--disabled': !row.dob}"
          >
            {{ dateFormat(row.dob) }}
          </button>
        </template>
        <template #age_type="{ row }">
          <div class="table-default__flex">
            <img v-if="row.age_type" :src="require(`@/assets/img/${row.age_type}-icon.svg`)" alt="">
            <img v-else src="@/assets/img/age-null-icon.svg" alt="">
            <button
              v-if="row.age"
              @click="onCopyToClipboard(row.age)"
              class="table-default__copy"
              :class="{'table-default__copy--disabled': !row.age}"
            >
              {{ row.age }}
            </button>
          </div>
        </template>
        <template #food_preference="{ row }">
          <button
            v-if="row.food_preference"
            @click="onCopyToClipboard(row.food_preference.name)"
            class="table-default__copy"
            :class="{'table-default__copy--disabled': !row.food_preference}"
          >
            {{ row.food_preference.name }}
          </button>
          <template v-else>-</template>
          <div v-if="row.food_gluten_free || row.food_lactose_free || row.food_halal || row.food_no_chicken || row.food_no_red_meat" class="table-default__controls">
            <span v-if="row.food_gluten_free" class="status-tag" :style="{ 'backgroundColor': '#a865eb' }">Gluten-free</span>
            <span v-if="row.food_lactose_free" class="status-tag" :style="{ 'backgroundColor': '#5e99e6' }">Lactose-free</span>
            <span v-if="row.food_halal" class="status-tag" :style="{ 'backgroundColor': '#4cb184' }">Halal</span>
            <span v-if="row.food_no_chicken" class="status-tag" :style="{ 'backgroundColor': '#e6b85e' }">No chicken</span>
            <span v-if="row.food_no_red_meat" class="status-tag" :style="{ 'backgroundColor': '#e65e81' }">No red meat</span>
          </div>
        </template>
        <template #allergy="{ row }">{{ row.allergy || '-' }}</template>
      </v-client-table>
    </template>
  </app-page-container>
</template>

<script>
import { format, parse } from 'date-fns'
import { getReservationsMealGuest } from '@/http'

export default {
  name: 'ReservationMealClients',
  props: {
    mealData: Object,
  },
  data() {
    return {
      is_page_loaded: false,
      table_personal: {
        items: [],
        columns: ['count', 'full_name', 'dob', 'age_type', 'food_preference', 'allergy'],
        options: {
          headings: {
            count: '#',
            full_name: 'Full name',
            dob: 'Date of birth',
            age_type: 'Age',
            food_preference: 'Diet',
            allergy: 'Allergies',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      getReservationsMealGuest(this.mealData.hotel.id)
        .then(res => {
          this.table_personal.items = res.data
          this.is_page_loaded = true
        })
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
    onCopyToClipboard(string) {
      navigator.clipboard.writeText(string)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Copied to clipboard',
          })
        })
        .catch(() => { console.error('Something went wrong') })
    },
  }
}
</script>
